import React, { useState } from 'react'
import Navbar from '../../Navbar/Navbar'
import "./Summary.css"
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { partBookingDetails } from '../../../../Redux/Slice/AuthSlice';

const PartySummary = () => {
  const [selectedPayment, setSelectedPayment] = useState('credit');
 // const [storePayment, setStorePayment] = useState(true);
  //const [recurring, setRecurring] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const amount = 249.00;

  const location = useLocation()
  const {partyBookingDetails} = useSelector((state)=>state.Auth)
  const dataSlot = location.state

  const partBookingObject = {...partyBookingDetails[0],...partyBookingDetails[1],...partyBookingDetails[2],...partyBookingDetails[3],selectedPayment}
  console.log(partBookingObject)
  const handleSummary = ()=>{
    const data = {...selectedPayment,...amount,...dataSlot?.dataSlot}
    dispatch(partBookingDetails(JSON.stringify({data:partBookingObject,message:"summary"})))
    navigate('/portal/booking/party/warning',{state:data})
  }
  return (
<div className="kiga-portal-package-main">
      <Navbar />
      <div className="kiga-portal-package-head-title">
        <p>Party Booking</p>
      </div>
      <section className='kiga-portal-package-section'>
        <div className='kiga-portal-package-section-title'>
          <p>Summary</p>
        </div>
        <div className='kiga-portal-summary-section-back'>
          <div className='kiga-portal-summary-section-title'>
            <p>Party Summary</p>
          </div>
          <div className='kiga-portal-summary-section-grid'>
            <div className="kiga-portal-summary-section-grid-flex">
              <div className="kiga-portal-summary-section-grid-section-label">
                <p>Place:</p>
              </div>
              <div className="kiga-portal-summary-section-grid-input">
                <p>{dataSlot?.name}</p>
              </div>
            </div>
            <div className="kiga-portal-summary-section-grid-flex">
              <div className="kiga-portal-summary-section-grid-section-label">
                <p>Date/Time:</p>
              </div>
              <div className="kiga-portal-summary-section-grid-input">
                <p>10 Jan 2027 </p>
                <p>{dataSlot?.dataSlot}</p>
              </div>
            </div>
            <div className="kiga-portal-summary-section-grid-flex">
              <div className="kiga-portal-summary-section-grid-section-label">
                <p>Package:</p>
              </div>
              <div className="kiga-portal-summary-section-grid-input">
                <p>{dataSlot?.name}</p>
              </div>
            </div>
            <div className="kiga-portal-summary-section-grid-flex">
              <div className="kiga-portal-summary-section-grid-section-label">
                <p>Number of Guests:</p>
              </div>
              <div className="kiga-portal-summary-section-grid-input">
                <p>{dataSlot?.numberOfGuest}</p>
              </div>
            </div>
            <div className="kiga-portal-summary-section-grid-flex">
              <div className="kiga-portal-summary-section-grid-section-label">
                <p>Group/Party Nickname:</p>
              </div>
              <div className="kiga-portal-summary-section-grid-input">
                <p>{dataSlot?.partyName}</p>
              </div>
            </div>
            <div className="kiga-portal-summary-section-grid-flex">
              <div className="kiga-portal-summary-section-grid-section-label">
                <p>Contact:</p>
              </div>
              <div className="kiga-portal-summary-section-grid-input">
                <p>{dataSlot?.firstName + " " + dataSlot?.lastName}</p>
                <p>{dataSlot?.phone}</p>
                <p>{dataSlot?.email || "dallaswakabi@gmail.com"}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='kiga-portal-summary-section-back'>
          <div className='kiga-portal-summary-section-title'>
            <p>Party Summary</p>
          </div>
          <div className="summary-row">
            <span>Package: {dataSlot?.name}</span>
            <span>£{amount.toFixed(2)}</span>
         </div>
         <div className="divider" />

        <div className="summary-row">
          <span>Subtotal:</span>
          <span>£{amount.toFixed(2)}</span>
        </div>
        <div className="divider" />
        <div className="summary-row">
          <span>Tax:</span>
          <span>£0.00</span>
        </div>

        <div className="divider" />

        <div className="summary-row total-row">
          <span>Party Total:</span>
          <span>£{amount.toFixed(2)}</span>
        </div>
        
        <div className="full-amount">
        Full Amount: <strong>£{amount.toFixed(2)}</strong>
      </div>

      {/* Payment Method Selector */}
      <div className="payment-method-container">
        <div 
          className={`payment-option ${selectedPayment === 'credit' ? 'selected' : ''}`}
          onClick={() => setSelectedPayment('credit')}
        >
          <div className="radio-circle">
            {selectedPayment === 'credit' && <div className="radio-dot" />}
          </div>
          <span>Credit Card</span>
        </div>

        <div 
          className={`payment-option ${selectedPayment === 'other' ? 'selected' : ''}`}
          onClick={() => setSelectedPayment('other')}
        >
          <div className="radio-circle">
            {selectedPayment === 'other' && <div className="radio-dot" />}
          </div>
          <span>Other</span>
        </div>
      </div>
        <div className="kiga-portal-detail-other-section-btn">
         <button onClick={handleSummary}>Store Card On File</button>
         <p>By clicking 'Store Card On File', I agree to the Terms & Conditions and Returns, Refunds & Cancellation Policy for this transaction.</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PartySummary